<div class="modal-header">
  <h4 class="modal-title"> {{'editArticleNumberMappingPopup.title' | translate}}
    <a class="link ps-2" href="javascript:void(0)" data-gatm="global.label.help" (click)="openHELPLink()" tooltip [tooltipText]="'global.label.help' | translate"><app-svg-icon type="information_circle" [inline]="true"/></a>
  </h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner minh-200">
    <div class="d-flex align-items-center mb-2">
      <label class="font-weight-bold me-3">{{'editArticleNumberMappingPopup.label.activated_list' | translate}}:</label>
      <select class="form-control me-3" [(ngModel)]="activeArticleNumberMappingList" (change)="onActiveMappingListChanged()">
        <option *ngFor="let articleNumberMappingList of articleNumberMappingLists"
                [ngValue]="articleNumberMappingList">{{articleNumberMappingList.isDefault ? (articleNumberMappingList.name | translate) : articleNumberMappingList.name}}
        </option>
      </select>
      <a (click)="addNewMappingList()" tooltip [tooltipText]="'editArticleNumberMappingPopup.label.add_new_list' | translate"><app-svg-icon type="list-add" size="medium-small"/></a>
      <a [class.event-disabled]="activeArticleNumberMappingList.isDefault" (click)="removeMappingList()" tooltip [tooltipText]="'editArticleNumberMappingPopup.label.remove_list' | translate"><app-svg-icon type="delete" size="medium-small"/></a>
    </div>
    <table class="table table-hover table-striped number-mapping-table fixed-layout" fixedHeader>
      <thead>
      <tr>
        <th>{{'editArticleNumberMappingPopup.label.article_number' | translate}}</th>
        <th>{{'editArticleNumberMappingPopup.label.custom_article_number' | translate}}</th>
        <th class="dots">
          <span class="dropdown" dropdown #dropdown="bs-dropdown">
                <a data-toggle="dropdown" dropdownToggle (click)="false"><i class="mdi mdi-dots-vertical c-pointer green"></i></a>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                  <li><a class="dropdown-item" (click)="addArticleNumberMapping()"><app-svg-icon type="plus" size="medium-small"/>{{'global.label.add' | translate}}</a></li>
                  <li><a class="dropdown-item" (click)="deleteAllArticleNumberMappings()"><app-svg-icon type="delete" size="medium-small"/>{{'global.label.delete_all' | translate}}</a></li>
                  <li><a class="dropdown-item" (click)="exportArticleNumberMappings()"><app-svg-icon type="export" size="medium-small"/>{{'global.label.export' | translate}}</a></li>
                  <li><a class="dropdown-item" (click)="importInput.click()"><app-svg-icon type="import" size="medium-small"/>{{'global.label.import' | translate}}</a></li>
                  <li><a class="dropdown-item" (click)="addToFavoritesButtonClickHandler()"><app-svg-icon type="list-add" size="medium-small"/>{{'editArticleNumberMappingPopup.label.addToFavorites' | translate}}</a></li>
                  <li *ngIf="!editedCollection"><a class="dropdown-item" [class.event-disabled]="!addToNotFavoriteAvailable" (click)="addToLibraryButtonClickHandler()"><app-svg-icon type="list-add" size="medium-small"/>{{'editArticleNumberMappingPopup.label.addToSomeLibrary' | translate}}</a></li>
                  <li *ngIf="addToEditedCollectionAvailable"><a class="dropdown-item" (click)="addToLibraryButtonClickHandler()"><app-svg-icon type="list-add" size="medium-small"/>{{'editArticleNumberMappingPopup.label.addToCurrentLibrary' | translate : { '0': (editedCollection.name | truncate : 20) } }}</a></li>
                </ul>
            </span>
        </th>
      </tr>
      </thead>
    </table>
    <div class="overflow-xh" style="min-height: 180px">
      <table class="table table-hover table-striped number-mapping-table fixed-layout mb-0">
        <tbody minRowCount [update]="update">
        <tr *ngFor="let articleNumberMapping of activeArticleNumberMappingList.entries; let i = index"
            [class.active]="articleNumberMapping === selectedArticleNumberMapping">
          <td (click)="toggleMapping(articleNumberMapping)">
            {{articleNumberMapping.articleNumber}}
          </td>
          <td (click)="toggleMapping(articleNumberMapping)">
            {{articleNumberMapping.customArticleNumber}}
          </td>
          <td (click)="selectMapping(articleNumberMapping)" class="dots">
            <span class="dropdown" dropdown #dropdown="bs-dropdown" [dropup]="i === activeArticleNumberMappingList.entries.length - 1 && i > 0">
                <a data-toggle="dropdown" dropdownToggle (click)="false"><i class="mdi mdi-dots-vertical c-pointer small"></i></a>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                  <li><a class="dropdown-item" (click)="editArticleNumberMapping()"><app-svg-icon type="edit-pen" size="medium-small"/>{{'global.label.edit' | translate}}</a></li>
                  <li><a class="dropdown-item" (click)="deleteArticleNumberMapping()"><app-svg-icon type="delete" size="medium-small"/>{{'global.label.delete' | translate}}</a></li>
                </ul>
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <input class="d-none" type="file" id="selectFileButton" accept=".csv" #importInput (change)="importArticleNumberMappings($event)">
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="cancelButton_clickHandler()">
    {{'global.label.cancel' | translate}}
  </button>
  <button type="submit" class="btn btn-primary btn-forward" (click)="saveButton_clickHandler()">
    {{'global.label.save' | translate}}
  </button>
</div>
